// extracted by mini-css-extract-plugin
export default {"box":"glDF10xlja7XSskPDXuz","emptyList":"g4no4MQdJpKpXUsWv0lk"};